import moment from "moment";
const rp = require("request-promise");

export const getAustralianData = () => {
  return new Promise((resolve, reject) => {
    const options = {
      uri: "https://covid-193.p.rapidapi.com/history",
      qs: {
        country: "Australia"
      },
      headers: {
        "x-rapidapi-host": "covid-193.p.rapidapi.com",
        "x-rapidapi-key": "68d500cdc1msh79e83cfd9eb6e00p1ad24cjsn829c976aa34d"
      },
      json: true // Automatically parses the JSON string in the response
    };

    rp(options)
      .then(function(response) {
        let data = response.response;
        data = data.reverse();
        let currentDate = "";
        let dailyData = [];

        data.forEach(dataPoint => {
          let day = moment(dataPoint.time).format("DD/MM/YYYY");
          if (day !== currentDate) {
            currentDate = day;
            dailyData.push(dataPoint);
          }
        });

        let filteredData = dailyData.map(dataPoint => {
          return {
            dateStamp: dataPoint.time,
            cases: dataPoint.cases,
            deaths: dataPoint.deaths
          };
        });

        let dateRange = filteredData.map(dataPoint => {
          return moment(dataPoint.dateStamp).format("DD/MM");
        });

        const australianStatistics = (
          graphLabel,
          graphColor,
          graphDataKey,
          graphKeyTwo
        ) => {
          return {
            label: graphLabel,
            backgroundColor: graphColor,
            data: filteredData.map(dataPoint => {
              return dataPoint[graphDataKey][graphKeyTwo];
            })
          };
        };

        let activeCaseData = australianStatistics(
          "Australian Active Infections",
          "rgba(0, 132, 61, 0.5)",
          "cases",
          "active"
        );

        let totalCaseData = australianStatistics(
          "Australian Total Cases",
          "rgba(25, 85, 121, 0.7)",
          "cases",
          "total"
        );

        let criticalCaseData = australianStatistics(
          "Australian Critical Cases",
          "rgba(237, 174, 73, 0.7)",
          "cases",
          "critical"
        );

        let recoveredCaseData = australianStatistics(
          "Australian Recovered Cases",
          "rgba(124, 234, 156, 0.7)",
          "cases",
          "recovered"
        );

        let totalDeathData = australianStatistics(
          "Australian Total Deaths",
          "rgba(206, 45, 53, 0.7)",
          "deaths",
          "total"
        );

        let newCaseData = {
          label: "Australian New Infections",
          backgroundColor: "rgba(134, 179, 205, 0.7)",
          data: filteredData.map((dataPoint, index) => {
            let indexToCheck = index === 0 ? index : index - 1;

            return (
              dataPoint.cases.total - filteredData[indexToCheck].cases.total
            );
          })
        };

        let newDeathData = {
          label: "Australian New Deaths",
          backgroundColor: "rgba(252, 127, 133, 0.7)",
          data: filteredData.map((dataPoint, index) => {
            let indexToCheck = index === 0 ? index : index - 1;

            return (
              dataPoint.deaths.total - filteredData[indexToCheck].deaths.total
            );
          })
        };

        let dataSets = {
          activeCaseData: activeCaseData,
          newCaseData: newCaseData,
          totalCaseData: totalCaseData,
          criticalCaseData: criticalCaseData,
          recoveredCaseData: recoveredCaseData,
          newDeathData: newDeathData,
          totalDeathData: totalDeathData
        };

        let dataObject = {
          dateRange: dateRange,
          dataSets: dataSets
        };

        resolve(dataObject);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};
